import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "search-form search-form--rail" }
const _hoisted_2 = { class: "form-wrapper form-wrapper" }
const _hoisted_3 = { class: "search-form__destination" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "search-form__destination__title" }, "Маршрут", -1)
const _hoisted_5 = { class: "search-form__destination search-form__destination--rail" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "search-form__destination__title" }, "Даты", -1)
const _hoisted_7 = { class: "search-form__destination search-form__destination--rail" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "search-form__destination__title" }, "Пассажиры", -1)
const _hoisted_9 = { class: "count-wrapper" }
const _hoisted_10 = { class: "buttons-wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rail_search_input = _resolveComponent("rail-search-input")
  const _component_datepicker = _resolveComponent("datepicker")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("form", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("label", null, [
            _createVNode(_component_rail_search_input, {
              onSelectData: _ctx.selectFrom,
              placeholder: "Откуда"
            }, null, 8, ["onSelectData"])
          ]),
          _createVNode("label", null, [
            _createVNode(_component_rail_search_input, {
              onSelectData: _ctx.selectTo,
              placeholder: "Куда"
            }, null, 8, ["onSelectData"])
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_datepicker, {
            placeholder: "Дата",
            "monday-first": true,
            onSelected: _ctx.setDateFrom,
            "wrapper-class": "vuejs3-datepicker__wrapper--one-way",
            "disabled-dates": _ctx.disabledDatesFrom
          }, null, 8, ["onSelected", "disabled-dates"])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Accordion, null, {
            default: _withCtx(() => [
              _createVNode(_component_AccordionTab, {
                header: 
                `Кол-во пассажиров: ${_ctx.passengersCount}`
              
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("h4", null, " Пассажиры: " + _toDisplayString(_ctx.passengersCount), 1),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("button", {
                        disabled: _ctx.passengersCount === 4,
                        class: "btn-plus",
                        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.increaseCount()), ["prevent"]))
                      }, null, 8, ["disabled"]),
                      _createVNode("button", {
                        disabled: _ctx.passengersCount === 1,
                        class: "btn-minus",
                        onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.decreaseCount()), ["prevent"]))
                      }, null, 8, ["disabled"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          }),
          _createVNode("button", {
            type: "submit",
            class: "search-form__submit search-form__submit--rail ml-a",
            onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.searchData(...args)), ["prevent"])),
            disabled: !_ctx.disabledSearch
          }, null, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}